import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class QueryParamGuard implements CanActivate {
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const queryParams = route.queryParams;

    if (queryParams && queryParams['token']) {
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}
